var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-bar'),_c('router-view'),_c('aplayer',{ref:"aplayer",attrs:{"audio":_vm.musicdata,"fixed":"","mini":"","autoplay":""},on:{"onLoadeddata":_vm.play,"onPlay":_vm.play,"listSwitch":_vm.play}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }